import {Component} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";

import {AngularEditorComponent} from "../../../editor/angular-editor/angular-editor.component";
import {FIELD_VIEW_PROVIDERS, FieldsBaseComponent} from "../fields-base/fields-base.component";

@Component({
    selector: 'app-editor-field',
    imports: [
    FieldsBaseComponent,
    ReactiveFormsModule,
    AngularEditorComponent
],
    templateUrl: './editor-field.component.html',
    styleUrl: './editor-field.component.scss',
    viewProviders: FIELD_VIEW_PROVIDERS
})
export class EditorFieldComponent extends FieldsBaseComponent<string> {
}
